import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import * as React from "react"
import { useEffect, useState } from "react"
import Slider, { Settings } from "react-slick"

import Dot from "./dot"
import DotsContainer from "./dots-container"

interface Props extends Settings {
  disabled?: boolean
  children: React.ReactNode
  onChange?: (index: number) => void
  durationInSeconds?: number
}

const SlickSlider: React.FC<Props> = ({
  disabled,
  children,
  onChange,
  initialSlide = 0,
  durationInSeconds,
  ...props
}) => {
  const sliderRef = React.useRef<Slider>(null)
  const [activeIndex, setActiveIndex] = useState(initialSlide)
  useEffect(() => {
    if (durationInSeconds) {
      const interval = setInterval(() => {
        sliderRef.current?.slickNext()
      }, durationInSeconds * 1000)
      return () => clearInterval(interval)
    }
  }, [durationInSeconds, activeIndex])

  function handleClick(type: number) {
    sliderRef.current?.slickGoTo(type)
  }
  if (disabled) {
    return children as React.ReactElement
  }
  return (
    <Slider
      {...props}
      initialSlide={initialSlide}
      appendDots={dots => <DotsContainer dots={dots} />}
      customPaging={index => (
        <Dot
          key={index}
          isActive={index === activeIndex}
          onClick={() => handleClick(index)}
          durationInSeconds={durationInSeconds}
        />
      )}
      ref={sliderRef}
      beforeChange={(_, next) => {
        setActiveIndex(next)
        onChange?.(next)
      }}
      arrows={false}
    >
      {children}
    </Slider>
  )
}

export default SlickSlider
